import { render, staticRenderFns } from "./SidebarBlini.vue?vue&type=template&id=415efc04&scoped=true"
import script from "./SidebarBlini.vue?vue&type=script&lang=js"
export * from "./SidebarBlini.vue?vue&type=script&lang=js"
import style0 from "./SidebarBlini.vue?vue&type=style&index=0&id=415efc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415efc04",
  null
  
)

export default component.exports